module.exports = __webpack_public_path__ + "static/media/logo.00efe491.png";